import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";

import { doREQUEST_ERROR, doREQUEST_COMPLETE, doGARMIN_DIRECT_BBI_DIGEST_SET } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_PROJECT_GARMIN_BBI_DATA_DIGEST_FETCH =
  "REQUEST_PROJECT_GARMIN_BBI_DATA_DIGEST_FETCH";
export const doREQUEST_PROJECT_GARMIN_BBI_DATA_DIGEST_FETCH = createDoRequestAction(
  REQUEST_PROJECT_GARMIN_BBI_DATA_DIGEST_FETCH,
);

export const requestProjectBbiDataDigestActionCreators = {
  doREQUEST_PROJECT_GARMIN_BBI_DATA_DIGEST_FETCH,
};

export function* requestProjectGarminBbiDataDigest({
  payload,
  setRequestResult,
}: any): SagaIterator {
  debug("saga*requestProjectDataDigest");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
        yymmddIndexList: v.array().items(v.number()),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_GARMIN_BBI_DATA_DIGEST_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { projectId, yymmddIndexList } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/project-garmin-direct-bbi-data-digest`,
    accessToken,
    data: {
      projectId,
      yymmddIndexList,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_GARMIN_BBI_DATA_DIGEST_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v2/web/project-garmin-direct-bbi-data-digest",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  // console.log('project garmin bbi data digest', result.payload)

  yield put(
    doGARMIN_DIRECT_BBI_DIGEST_SET({
      ...result.payload,
    }),
  );

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_GARMIN_BBI_DATA_DIGEST_FETCH,
        fromPayload: payload,
        requestId: payload.requestId,
        url: "/v2/web/project-garmin-direct-bbi-data-digest",
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* projectGarminBbiDataDigestSaga() {
  yield takeEvery(REQUEST_PROJECT_GARMIN_BBI_DATA_DIGEST_FETCH, requestProjectGarminBbiDataDigest);
}
